module.exports = __webpack_public_path__ + "img/Pot2.03d189bf.svg";